import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, resourcesHelper, Types} from "@falcon/services";
import {Link} from "react-router-dom";
import {Overlay} from "@athena-portal/components";

interface IState {
    hasMta?: boolean;
}

interface IProps {
    policyNumber?: string

}

export class UpdateOtherPolicesBanner extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: any) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.policyNumber === undefined) {
            this.customerPortalService.accountHasPolicyWith24hOldMTA()
                .subscribe((hasMta: boolean) => {
                    this.setState({hasMta});
                });
        } else {
            this.customerPortalService.policyHas24hOldMTA(this.props.policyNumber)
                .subscribe((hasMta: boolean) => {
                    this.setState({hasMta});
                });
        }

    }

    public render() {
        if (this.state?.hasMta === undefined) {
            // display loading screen when data is fetched
            return <Overlay show={true} />;
        } else {
            return this.state.hasMta && <div className="banner background-color-white-blue">
                <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"/>
                <div className="banner-text">
                    Please don't forget to
                    {" "}
                    {this.props.policyNumber ?
                        <Link id="dashboard-link" to={'/dashboard'} className="text-decoration-underline text-blue-1 muli-bold-16">
                            go into your other policies
                        </Link>
                        :
                        <>go into your other policies</>
                    }
                    {" "}
                    if you need to apply the same change(s) to them.
                </div>
            </div>
        }

    }

}
